__turbopack_context__.v({
  "bullet": "kDTy8q_bullet",
  "bullet-wrapper": "kDTy8q_bullet-wrapper",
  "extras": "kDTy8q_extras",
  "usp-card": "kDTy8q_usp-card",
  "usps": "kDTy8q_usps",
});
